/**
 * Language names as people and the job pipeline write them, in English, Finnish and Swedish,
 * mapped to one code so "Finnish", "suomi", "Suomen kieli" and "finska" compare equal. Covers the
 * languages Finnish job ads actually ask for; anything else falls back to its lowercased name.
 */
const NAMES: Record<string, string> = {
  finnish: 'fi', suomi: 'fi', 'suomen kieli': 'fi', finska: 'fi',
  swedish: 'sv', ruotsi: 'sv', 'ruotsin kieli': 'sv', svenska: 'sv',
  english: 'en', englanti: 'en', 'englannin kieli': 'en', engelska: 'en',
  german: 'de', saksa: 'de', tyska: 'de',
  french: 'fr', ranska: 'fr', franska: 'fr',
  spanish: 'es', espanja: 'es', spanska: 'es',
  russian: 'ru', venäjä: 'ru', ryska: 'ru',
  estonian: 'et', viro: 'et', eesti: 'et', estniska: 'et',
  norwegian: 'no', norja: 'no', norska: 'no',
  danish: 'da', tanska: 'da', danska: 'da',
  italian: 'it', italia: 'it', italienska: 'it',
  chinese: 'zh', kiina: 'zh', kinesiska: 'zh',
  japanese: 'ja', japani: 'ja', japanska: 'ja',
  arabic: 'ar', arabia: 'ar', arabiska: 'ar',
  polish: 'pl', puola: 'pl', polska: 'pl',
  ukrainian: 'uk', ukraina: 'uk', ukrainska: 'uk',
  dutch: 'nl', hollanti: 'nl', nederländska: 'nl', holländska: 'nl',
  portuguese: 'pt', portugali: 'pt', portugisiska: 'pt',
};

export function languageCode(name: string): string {
  const key = name.trim().toLowerCase().replace(/\s+/g, ' ');
  return NAMES[key] ?? key;
}
